import { Injectable } from "@angular/core";
import { LoadingController, ToastController } from "@ionic/angular";

/**
 * Class of message service
 * @author Starley Cazorla
 */

@Injectable()
export class MessageService {
    private loading: any;

    constructor(private toastCtrl: ToastController,
        private loadingController: LoadingController) {

    }

    async showToast(message: string, color: string, position: "bottom" | "middle" | "top", duration: number, _clButton: boolean) {
        let toast = await this.toastCtrl.create({
            message: message,
            color: color,
            position: position,
            buttons: ['X'],
            duration: duration,
            keyboardClose: true
        });

        return await toast.present();

    };

    async startLoading(msg?: string, duration?: number) {
        this.loading = await this.loadingController.create(
            {
                message: msg ? msg : "Carregando...",
                duration: duration ? duration : 10000
            }
        );
        this.loading.present();
    }

    async endLoading() {
        if (this.loading) {
            this.loading.dismiss();
        }
    }

}
